<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex align-center sm12>
        <v-card tile>
          <v-card-text class="ma-2">
              <v-row dense>
                <v-col cols="10">
                  <v-text-field
                    v-model="params.cve_empleado"
                    label="Clave Empleado"
                    outlined
                    dense/>
                </v-col>
                <v-col cols="2">
                  <v-btn @click="findEmpleado" color="success" dark ><v-icon left>mdi-file-search</v-icon> Buscar</v-btn>
                </v-col>

                <v-col cols="12">
                  <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <NominaMainDialog v-if="get_dialogMain.dialog" :model="nomina" :view="view"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import NominaMainDialog from '@/components/dialogs/nomina/NominaMainDialog'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Periodo', value: 'periodo.descripcion', class: 'black--text' },
          { text: 'Area de Trabajo', value: 'adscripcion.departamento.nombre', class: 'black--text' },
          { text: 'Nombre Completo', value: 'adscripcion.empleado.NombreCompleto', class: 'black--text' },
          { text: 'Puesto', value: 'adscripcion.plaza.puesto.nombre', class: 'black--text' },
          { text: 'Categorria', value: 'adscripcion.plaza.categoria.nombre', class: 'black--text' },
          { text: 'Plaza', value: 'adscripcion.plaza.nombre', class: 'black--text' },
          { text: 'Bruto', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'Bruto' },
          { text: 'ISPT', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'total_impuestos_retenidos' },
          { text: 'Subsidio', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'total_otros_pagos' },
          { text: 'Neto', value: 'FieldDinamicDataSimple', class: 'black--text', action: 'FormatNumberMoney', field: 'Neto' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Ver Detalles', icon: 'mdi-eye', color: 'blue darken-1', action: 'viewData', code: 'libre', hidden: '' },
          { title: 'Recibo Nomina', icon: 'mdi-file-pdf-box', color: 'yellow darken-3', action: 'ExportRecibo', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: {
      cve_empleado: ''
    },
    nomina: {},
    view: null
  }),
  components: {
    DataTableMain,
    NominaMainDialog
  },
  mounted () {
  },
  methods: {
    ...mapActions(['postServiceListAction', 'getUrlServices', 'getUrExporPdftDataServerAction']),
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    // *-----*------*-----*------*-----*------*-----*------* \\
    successAction (item) {
      this[item.action](item)
    },

    tableAction (item) {
      this[item.action](item)
    },
    viewData (item) {
      this.view = item.item
      this.SHOW_DIALOG_MAIN({ type: 'viewDetilConcepts', with: 750, title: `${item.item.adscripcion.empleado.cve_empleado} - ${item.item.adscripcion.empleado.NombreCompleto}`, form: 'NominaDetalleConceptos' })
    },
    ExportRecibo (item) {
      const url = this.get_urls['GET/recibos/empleado/{nomina_id}[/{adscripcion_id}]']
      this.getUrExporPdftDataServerAction({ url: url, params: `/${item.item.padre_id}/${item.item.adscripcion_id}`, replace: '/{nomina_id}[/{adscripcion_id}]', nombre: item.item.folio })
    },
    // *-----*------*-----*------*-----*------*-----*------* \\
    findEmpleado () {
      if (this.params.cve_empleado !== '') {
        this.table.header.loading = true
        this.getUrl('POST/recibos/empleado/show')
        return
      }
      this.$swal({
        type: 'warning',
        icon: 'warning',
        title: 'Advertencia!',
        text: 'Para buscar los recibos es necesario ingresar clave empleado valido !!'
      })
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_dialogMain'])
  },
  watch: {
    get_urls () {
      this.getUrl('POST/recibos/empleado/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  }
}
</script>

<style>

</style>
